define('AwaLabs.AddModelToContext', [
    'QuantityPricing.View',
    'Cart.AddToCart.Button.View',
    'underscore'
], function AwaLabsLoginForPricing(
    QuantityPricingView,
    CartAddToCartButtonView,
    _
) {
    'use strict';

    _.extend(CartAddToCartButtonView.prototype, {
        getContext: _.wrap(CartAddToCartButtonView.prototype.getContext, function wrapContext(fn) {
            var context = fn.apply(this, _.toArray(arguments).slice(1));

            context.model = this.model;

            return context;
        })
    });

    _.extend(QuantityPricingView.prototype, {
        getContext: _.wrap(QuantityPricingView.prototype.getContext, function wrapContext(fn) {
            var context = fn.apply(this, _.toArray(arguments).slice(1));

            context.model = this.model;

            return context;
        })
    });
});
